export const templateIdLogo = "dbb44ac0536f11e6a4a5718c9f5aaf8e";
export const templateIdLogoConnectivity = "398a6020174d11e7aaa019b007565396";
export const templateIdFiles = "0fa62c90537011e6b8c4e97e4e524338";
export const templateIdFilesWithoutEncoding =
  "218b9680bdd511e89084dbb3150a8b6f";
export const transloaditAuthKey = "a15e0eb0536f11e680e9b14dfa3a2cbc";
export const transloaditAuthSecret = "b108f2064eb0e98260fcc430c6537cdb81477983";
